/**
 * Blocks third-party add-to-cart controls on bowl product pages outside the US.
 */
(function () {
  const body = document.body;
  if (!body?.classList.contains('reves-bowl-product')) return;

  const country = (body.dataset.revesCountry || '').toUpperCase();
  if (country === 'US') return;

  const blockedMessage =
    body.dataset.revesBowlUsMessage ||
    'Açaí bowls are only available for shipping within the United States.';

  function blockElement(el) {
    if (!el || el.dataset.revesBowlUsGuard === '1') return;
    el.dataset.revesBowlUsGuard = '1';
    if (el.tagName === 'FORM') {
      el.addEventListener(
        'submit',
        (e) => {
          e.preventDefault();
          e.stopPropagation();
        },
        true
      );
    }
    if ('disabled' in el) {
      el.disabled = true;
    }
    el.setAttribute('aria-disabled', 'true');
    el.style.pointerEvents = 'none';
    el.style.opacity = '0.55';
  }

  function guardThirdPartyAddToCart() {
    const selectors = [
      'form[action*="/cart/add"]',
      'button[name="add"]',
      '[class*="tpo"] button[type="submit"]',
      '.tpo-add-to-cart',
      '[data-tpo-add-to-cart]',
    ];

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        const form = el.closest('form');
        const productForm = el.closest('product-form-component');
        if (productForm?.dataset.revesBowlUsBlocked === 'true') return;
        if (form && !form.closest('product-form-component')) {
          blockElement(form);
        }
        if (el.matches('button[name="add"], [class*="tpo"] button[type="submit"], .tpo-add-to-cart')) {
          blockElement(el);
        }
      });
    });

    if (!document.querySelector('.reves-bowl-us-only-notice')) {
      const notice = document.createElement('p');
      notice.className = 'reves-bowl-us-only-notice reves-bowl-us-only-notice--tpo cart-primary-typography';
      notice.setAttribute('role', 'alert');
      notice.textContent = blockedMessage;
      const anchor =
        document.querySelector('.tpo_total-additional-price-wrapper') ||
        document.querySelector('[class*="tpo"]') ||
        document.querySelector('product-form-component');
      if (anchor?.parentElement) {
        anchor.parentElement.insertBefore(notice, anchor);
      }
    }
  }

  guardThirdPartyAddToCart();
  const observer = new MutationObserver(() => guardThirdPartyAddToCart());
  observer.observe(document.body, { childList: true, subtree: true });
})();
